import React, { useEffect, useState, useRef, useMemo } from 'react';
import {
  PageButtonIcon,
  PageButtonNumber,
  Container,
  ThisCard,
  ScrollOS,
  StatsRow,
  StatCard,
  ResumoStatusCard,
  ChartWrapper,
  Status,
  ProposalStateList,
  StatCardContent,
  StatCardRow,
  InputContainer,
  InputContent,
} from './styles';
import * as XLSX from 'xlsx-color';
import { Chart } from '~/componentes/PieChart';

import { store } from '~/store';
import { loadingToggle } from '~/store/modules/loadingModal/actions';

import { pdf } from '@react-pdf/renderer';
import RelatorioOsPDF from '~/componentes/TemplatePDF/RelatorioOS';

// import { renderToString } from 'react-dom/server';
// import { jsPDF } from 'jspdf';

import IconProjeto from '~/assets/icones/IconProjeto.svg';
import IconExcel from '~/assets/icones/IconExcel.svg';
import IconExcelB from '~/assets/icones/IconExcelB.svg';
import IconPdf from '~/assets/icones/IconePdf.svg';
import IconPdfB from '~/assets/icones/IconePdfB.svg';
// import OsTemplate from './Template/OsTemplate';
// import NunitoSemiBold from '~/utils/Nunito-semiBold.js';

import InputSelect from '~/componentes/Inputs/InputSelect';
import InputDate from '~/componentes/Inputs/InputDate';
import InputText from '~/componentes/Inputs/InputText';
import api from '~/services/api';
import { Colors } from '~/config/Colors';
// import OsPdfDownload from '~/componentes/TemplatePDF/RelatorioOS/OsPdfDownload';

function CustomBodyContent({
  data,
  previsaoInicio,
  setPrevisaoInicio,
  previsaoFinal,
  setPrevisaoFinal,
  idCliente,
  setIdCliente,
  statusAprovacao,
  setStatusAprovacao,
  idAnalista,
  setIdAnalista,
  idProjeto,
  setIdProjeto,
  idOS,
  setIdOS,
}) {
  const dispatch = store.dispatch;
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [pagAtiva, setPagAtiva] = useState(0);
  const [geraExcel, setGeraExcel] = useState(false);
  const [geraPdf, setGeraPdf] = useState(false);
  const sizePage = 10;
  const pdfRef = useRef(null);

  const [stats, setStats] = useState({
    totalOS: 0,
    total: '00:00',
    movidesk: '00:00',
    complementar: '00:00',
    translado: '00:00',
    totalPosHorario: '00:00',
  });
  const [chartData, setChartData] = useState([]);

  const [clientes, setClientes] = useState([]);
  // const [etapas, setEtapas] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const [projetos, setProjetos] = useState([]);

  const isDarkTheme = localStorage.getItem('tema') == 'E';

  const filteredData = useMemo(() => {
    const buscaId = String(idOS ?? '').trim();
    if (!buscaId) return data;

    return (data || []).filter(item => String(item?.id ?? '').includes(buscaId));
  }, [data, idOS]);

  const clientesOptions = clientes.map(item => ({
    value: String(item?.id),
    label: item?.nomeFantasia,
  }));

  const analistasOptions = analistas.map(item => ({
    value: String(item?.id),
    label: item?.nome,
  }));

  const projetosOptions = projetos.map(item => ({
    value: String(item?.id),
    label: item?.titulo,
  }));

  const statusOptions = [
    { value: 'A', label: 'Aguard. Aprovação Coord' },
    { value: 'C', label: 'Aguard. Aprovação Tec' },
    { value: 'T', label: 'Aguard. Encerramento' },
    { value: 'R', label: 'Reprovado Coordenador' },
    { value: 'S', label: 'Reprovado Tecnico' },
    { value: 'E', label: 'Encerrada' },
  ];

  // Todos os status possíveis de uma OS, para sempre aparecerem na legenda/gráfico e no excel
  const statusFixos = {
    A: { surname: 'Aguard. Aprovação Coord', fill: '#dee54d' },
    C: { surname: 'Aguard. Aprovação Tec', fill: '#76BD3E' },
    T: { surname: 'Aguard. Encerramento', fill: '#6796CF' },
    R: { surname: 'Reprovado Coordenador', fill: '#e68282' },
    S: { surname: 'Reprovado Tecnico', fill: '#e68282' },
    E: { surname: 'Encerrada', fill: '#707070' },
  };
  // const todosStatusValues = statusOptions.map(option => option.value);

  // horaApontada/horaDesconto/horaTranslado/horaTotal usam a convenção "horas.mm" (parte
  // decimal = minutos). O getter *Mascara do model (Sequelize) monta essa string via
  // ("00" + minutos).slice(-2), e minutos vem de uma conta com float (ex: (8.28-8)*100 =
  // 28.000000000000004) — o slice(-2) pega os últimos 2 dígitos da string toda, dando "04"
  // em vez de "28". Por isso formatamos aqui a partir do valor decimal bruto, sem usar o
  // *Mascara vindo da API.
  const formatarHoraDecimal = valor => {
    if (valor === null || valor === undefined) return '00:00';
    const horas = parseInt(valor);
    const minutos = Math.round((parseFloat(valor) - horas) * 100);
    return ('00' + horas).slice(-2) + ':' + ('00' + minutos).slice(-2);
  };

  const getTotalPosHorarioItem = item => {
    if (item?.tipoOS !== 'S') return '00:00';

    let minutos = 0;
    item?.atividades?.forEach(atividade => {
      atividade?.tarefas?.forEach(tarefa => {
        if (tarefa?.excluido) return;

        if (tarefa?.posHorario) {
          minutos += tarefa?.horaTotalMinuto || 0;
        }
      });
    });

    const horas = Math.floor(minutos / 60);
    const mins = minutos % 60;
    return `${String(horas).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  };

  const clearAllFilters = () => {
    setIdCliente(null);
    setIdAnalista(null);
    setIdProjeto(null);
    setIdOS(null);
    setStatusAprovacao(null);
    setPrevisaoInicio(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    setPrevisaoFinal(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
  };

  // const handleDownload = async () => {
  //   dispatch(loadingToggle());

  //   let htmlElement = <OsTemplate data={dataPage} />;
  //   let elementAsString = renderToString(htmlElement);

  //   const doc = new jsPDF({
  //     format: 'a4',
  //     unit: 'px',
  //     orientation: 'p',
  //   });
  //   doc.addFileToVFS('Nunito-semibold.ttf', NunitoSemiBold);
  //   doc.addFont('Nunito-semibold.ttf', 'Nunito', 'normal');
  //   doc.setFont('Nunito');

  //   doc.setFontSize(10);
  //   doc.html(elementAsString, {
  //     async callback(doc) {
  //       window.open(URL.createObjectURL(doc.output('blob')));
  //       dispatch(loadingToggle());
  //     },
  //   });
  // };

  useEffect(() => {
    if (geraPdf) {
      exportPdf();
      setGeraPdf(false);
    }
  }, [geraPdf]);

  console.log('dataPage', dataPage);
  // Add this new exportPdf function
  const exportPdf = async () => {
    dispatch(loadingToggle());

    try {
      const blob = await pdf(<RelatorioOsPDF key={Date.now()} data={dataPage} />).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
      console.error('Erro ao gerar PDF da OS:', error);
    } finally {
      setTimeout(() => {
        dispatch(loadingToggle());
      }, 1000);
    }
  };

  // const handleDownload = async () => {
  //   dispatch(loadingToggle());

  //   const htmlElement = <OsTemplate data={dataPage} />;
  //   const elementAsString = renderToString(htmlElement);

  //   const doc = new jsPDF({
  //     format: 'a4',
  //     unit: 'px',
  //     orientation: 'p',
  //   });
  //   doc.addFileToVFS('Nunito-semibold.ttf', NunitoSemiBold);
  //   doc.addFont('Nunito-semibold.ttf', 'Nunito', 'normal');
  //   doc.setFont('Nunito');
  //   doc.setFontSize(10);

  //   await doc.html(elementAsString, {
  //     margin: [0, 0, 0, 0],
  //     windowWidth: 1024,
  //     autoPaging: 'text',
  //     // pagebreak: { mode: ['css', 'legacy'] }, // habilita quebras via CSS
  //     pagebreak: {
  //       mode: ['css', 'legacy', 'avoid-all'],
  //       avoid: '.tickets-section, .linhas',
  //     },
  //     html2canvas: { scale: 1 },
  //     callback(pdf) {
  //       window.open(URL.createObjectURL(pdf.output('blob')));
  //       dispatch(loadingToggle());
  //     },
  //   });
  // };

  function addPagination(pag, maxPag) {
    const identificaAtivo = (paginaAtual, paginaAdd, points) => {
      if (!points) {
        return (
          <PageButtonNumber
            type="button"
            onClick={() => setPagAtiva(paginaAdd - 1)}
            key={paginaAdd}
            ativo={paginaAtual === paginaAdd ? 1 : undefined}
            numberdigits={paginaAdd}
          >
            <span />
            <p>{paginaAdd}</p>
          </PageButtonNumber>
        );
      } else {
        return <PageButtonNumber type="button">...</PageButtonNumber>;
      }
    };

    let itens = [];
    if (pag > 0) {
      if (maxPag === 0) {
        // html += identificaAtivo(0, 1);
      } else if (pag <= 3) {
        if (maxPag > 9) {
          itens.push(identificaAtivo(pag, 1));
          itens.push(identificaAtivo(pag, 2));
          itens.push(identificaAtivo(pag, 3));
          itens.push(identificaAtivo(pag, 4));
          itens.push(identificaAtivo(0, 0, true));
          itens.push(identificaAtivo(pag, maxPag - 3));
          itens.push(identificaAtivo(pag, maxPag - 2));
          itens.push(identificaAtivo(pag, maxPag - 1));
          itens.push(identificaAtivo(pag, maxPag));
        } else {
          for (var count = 1; count <= maxPag; count++) {
            itens.push(identificaAtivo(pag, count));
          }
        }
      } else if (pag <= maxPag - 3) {
        itens.push(identificaAtivo(pag, 1));
        itens.push(identificaAtivo(0, 0, true));
        itens.push(identificaAtivo(pag, pag - 2));
        itens.push(identificaAtivo(pag, pag - 1));
        itens.push(identificaAtivo(pag, pag));
        itens.push(identificaAtivo(pag, pag + 1));
        itens.push(identificaAtivo(pag, pag + 2));
        itens.push(identificaAtivo(0, 0, true));
        itens.push(identificaAtivo(pag, maxPag));
      } else if (pag > maxPag - 3) {
        if (maxPag > 9) {
          itens.push(identificaAtivo(pag, 1));
          itens.push(identificaAtivo(pag, 2));
          itens.push(identificaAtivo(pag, 3));
          itens.push(identificaAtivo(pag, 4));
          itens.push(identificaAtivo(0, 0, true));
          itens.push(identificaAtivo(pag, maxPag - 3));
          itens.push(identificaAtivo(pag, maxPag - 2));
          itens.push(identificaAtivo(pag, maxPag - 1));
          itens.push(identificaAtivo(pag, maxPag));
        } else {
          for (let count = 1; count <= maxPag; count++) {
            itens.push(identificaAtivo(pag, count));
          }
        }
      } else {
        itens.push(identificaAtivo(0, 1));
      }
    }
    return itens;
  }

  useEffect(() => {
    async function handleRequests() {
      api
        .get('/signed/empresa/gestorprojeto/gerencia/analistas', { params: { ativo: 1 } })
        .then(response => setAnalistas(response.data));

      api
        .get('/signed/empresa/gestorprojeto/cliente/clientes', { params: { ativo: 1 } })
        .then(response => setClientes(response.data));
    }

    handleRequests();
  }, []);

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/projetos', {
        params: { ativo: 1, ...(idCliente ? { idCliente } : {}) },
      })
      .then(response => setProjetos(response.data));
  }, [idCliente]);

  useEffect(() => {
    if (filteredData && filteredData?.length > 0) {
      let dados = [[]];
      let page = 0;
      let count = 0;

      for (const item of filteredData) {
        dados[page].push(item);

        if (sizePage == count + 1) {
          dados.push([]);

          count = 0;
          page++;
        }

        count++;
      }

      setPagAtiva(0);
      setDataPage(dados);
    } else {
      setPagAtiva(0);
      setDataPage([]);
    }
  }, [filteredData]);

  useEffect(() => {
    const converterParaMinutos = horaMascara => {
      if (!horaMascara) return 0;
      const partes = horaMascara.split(':');
      return parseInt(partes[0]) * 60 + parseInt(partes[1]);
    };

    const converterParaHora = minutos => {
      const horas = Math.floor(minutos / 60);
      const mins = minutos % 60;
      return `${String(horas).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    };

    const montarChartData = statusTotais =>
      Object.entries(statusFixos).map(([key, info]) => {
        const minutos = statusTotais[key] || 0;
        const horas = Math.floor(minutos / 60);
        const mins = minutos % 60;
        return {
          name: key,
          surname: info.surname,
          value: parseFloat(`${horas}.${String(mins).padStart(2, '0')}`),
          fill: info.fill,
        };
      });

    if (!filteredData || filteredData?.length === 0) {
      setStats({
        totalOS: 0,
        total: '00:00',
        movidesk: '00:00',
        complementar: '00:00',
        translado: '00:00',
        totalPosHorario: '00:00',
      });
      setChartData(montarChartData({}));
      return;
    }

    let minTotal = 0;
    let minMovidesk = 0;
    let minComplementar = 0;
    let minTranslado = 0;
    let minPosHorario = 0;
    const statusTotais = {};

    filteredData.forEach(item => {
      minTotal += converterParaMinutos(formatarHoraDecimal(item?.horaTotal));
      minTranslado += converterParaMinutos(formatarHoraDecimal(item?.horaTranslado));

      if (item?.tipoOS === 'S') {
        item?.atividades?.forEach(atividade => {
          atividade?.tarefas?.forEach(tarefa => {
            if (tarefa?.excluido) return;

            if (!tarefa?.idTicket || tarefa?.titulo === 'Atividade SRP') {
              minComplementar += tarefa?.horaTotalMinuto || 0;
            } else {
              minMovidesk += tarefa?.horaTotalMinuto || 0;
            }

            if (tarefa?.posHorario) {
              minPosHorario += tarefa?.horaTotalMinuto || 0;
            }
          });
        });
      }

      const key = item?.statusAprovacao;
      if (key) {
        statusTotais[key] =
          (statusTotais[key] || 0) + converterParaMinutos(formatarHoraDecimal(item?.horaTotal));
      }
    });

    setStats({
      totalOS: filteredData.length,
      total: converterParaHora(minTotal),
      movidesk: converterParaHora(minMovidesk),
      complementar: converterParaHora(minComplementar),
      translado: converterParaHora(minTranslado),
      totalPosHorario: converterParaHora(minPosHorario),
    });

    setChartData(montarChartData(statusTotais));
  }, [filteredData]);

  useEffect(() => {
    if (geraExcel && filteredData && filteredData?.length > 0) {
      let dados = [];
      let totalMinutosTotal = 0;

      dispatch(loadingToggle());

      // Soma os minutos de uma máscara "HH:MM"
      const converterParaMinutos = horaMascara => {
        if (!horaMascara) return 0;
        const partes = horaMascara.split(':');
        return parseInt(partes[0]) * 60 + parseInt(partes[1]);
      };

      const converterParaHora = minutos => {
        const horas = Math.floor(minutos / 60);
        const mins = minutos % 60;
        return `${String(horas).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
      };

      // Fração de dia (0 a 1) que o Excel usa internamente pra valores de hora/duração
      const converterParaFracaoExcel = horaMascara => converterParaMinutos(horaMascara) / 1440;
      const colunasHora = [
        'Apontada',
        'Horas Movidesk',
        'Horas Complementares',
        'Desconto',
        'Translado',
        'SRP Autorizado',
        'Total',
      ];

      let totalMinutosMovideskGeral = 0;
      let totalMinutosComplementarGeral = 0;
      let totalMinutosTransladoGeral = 0;
      let totalMinutosPosHorarioGeral = 0;
      let statusCodes = [];

      for (const item of filteredData) {
        // Apenas OS do tipo Suporte separam horas de tickets do Movidesk da tarefa complementar
        let horasMovidesk = '00:00';
        let tarefaComplementar = '00:00';
        let horasPosHorario = '00:00';

        if (item?.tipoOS === 'S') {
          let minutosMovidesk = 0;
          let minutosComplementar = 0;
          let minutosPosHorario = 0;

          item?.atividades?.forEach(atividade => {
            atividade?.tarefas?.forEach(tarefa => {
              if (tarefa?.excluido) return;

              if (!tarefa?.idTicket || tarefa?.titulo === 'Atividade SRP') {
                minutosComplementar += tarefa?.horaTotalMinuto || 0;
              } else {
                minutosMovidesk += tarefa?.horaTotalMinuto || 0;
              }

              if (tarefa?.posHorario) {
                minutosPosHorario += tarefa?.horaTotalMinuto || 0;
              }
            });
          });

          horasMovidesk = converterParaHora(minutosMovidesk);
          tarefaComplementar = converterParaHora(minutosComplementar);
          horasPosHorario = converterParaHora(minutosPosHorario);

          totalMinutosMovideskGeral += minutosMovidesk;
          totalMinutosComplementarGeral += minutosComplementar;
          totalMinutosPosHorarioGeral += minutosPosHorario;
        }

        dados.push({
          'Id OS': item?.id,
          Emissão: new Date(item?.dataEmissao)
            .toLocaleString('pt-BR', { timeZone: 'UTC' })
            .split(',')[0],
          'Data de Criação': item?.dataCadastro
            ? new Date(item?.dataCadastro)
                .toLocaleString('pt-BR', { timeZone: 'UTC' })
                .split(',')[0]
            : '',
          Titulo: item?.titulo,
          Analista: item?.analista?.nome,
          Etapa: item?.descricaoStatusAprov,
          // 'Status Aprovação': statusFixos[item?.statusAprovacao]?.surname || item?.statusAprovacao,
          Apontada: converterParaFracaoExcel(formatarHoraDecimal(item?.horaApontada)),
          'Horas Movidesk': converterParaFracaoExcel(horasMovidesk),
          'Horas Complementares': converterParaFracaoExcel(tarefaComplementar),
          Desconto: converterParaFracaoExcel(formatarHoraDecimal(item?.horaDesconto)),
          Translado: converterParaFracaoExcel(formatarHoraDecimal(item?.horaTranslado)),
          'SRP Autorizado': converterParaFracaoExcel(horasPosHorario),
          Total: converterParaFracaoExcel(formatarHoraDecimal(item?.horaTotal)),
          Projeto: item?.projeto?.titulo,
          Cliente: item?.cliente?.nomeFantasia,
          'Aprovador 1': item?.coordenador?.nome,
          'Aprovador 2': item?.coordenadorTec?.nome,
          'Observação Reprovação':
            item?.statusAprovacao === 'R' || item?.statusAprovacao === 'S' ? item?.observacao : '',
        });

        statusCodes.push(item?.statusAprovacao);
        totalMinutosTotal += converterParaMinutos(formatarHoraDecimal(item?.horaTotal));
        totalMinutosTransladoGeral += converterParaMinutos(
          formatarHoraDecimal(item?.horaTranslado),
        );
      }

      dados.push({
        'Id OS': 'TOTAL:',
        Emissão: '',
        'Data de Criação': '',
        Titulo: '',
        Analista: '',
        Etapa: '',
        // 'Status Aprovação': '',
        Apontada: '',
        'Horas Movidesk': totalMinutosMovideskGeral / 1440,
        'Horas Complementares': totalMinutosComplementarGeral / 1440,
        Desconto: '',
        Translado: totalMinutosTransladoGeral / 1440,
        'SRP Autorizado': totalMinutosPosHorarioGeral / 1440,
        Total: totalMinutosTotal / 1440,
        Projeto: '',
        Cliente: '',
        'Aprovador 1': '',
        'Aprovador 2': '',
        'Observação Reprovação': '',
      });

      const worksheet = XLSX.utils.json_to_sheet(dados);

      // Adiciona uma borda na célula de Status Aprovação com a cor correspondente ao status
      const colunas = Object.keys(dados[0] || {});

      // Formata as colunas de hora como duração de Excel ([h]:mm), não como texto
      colunasHora.forEach(coluna => {
        const colIndex = colunas.indexOf(coluna);
        if (colIndex === -1) return;

        for (let i = 0; i < dados.length; i++) {
          const cellRef = XLSX.utils.encode_cell({ r: i + 1, c: colIndex });
          const cell = worksheet[cellRef];
          if (cell && cell.t === 'n') {
            cell.z = '[hh]:mm';
          }
        }
      });
      // const colStatus = colunas.indexOf('Status Aprovação');
      // if (colStatus > -1) {
      //   data.forEach((item, i) => {
      //     const cellRef = XLSX.utils.encode_cell({ r: i + 1, c: colStatus });
      //     if (!worksheet[cellRef]) return;

      //     const corBorda = statusFixos[statusCodes[i]]?.fill?.replace('#', '') || 'CCCCCC';

      //     worksheet[cellRef].s = {
      //       border: {
      //         top: { style: 'thin', color: { rgb: corBorda } },
      //         bottom: { style: 'thin', color: { rgb: corBorda } },
      //         left: { style: 'thin', color: { rgb: corBorda } },
      //         right: { style: 'thin', color: { rgb: corBorda } },
      //       },
      //     };
      //   });
      // }

      // Ajusta a largura de cada coluna ao tamanho do seu maior conteúdo
      worksheet['!cols'] = colunas.map(coluna => {
        if (colunasHora.includes(coluna)) {
          return { wch: Math.max(coluna.length, 8) + 1 };
        }

        const maiorConteudo = dados.reduce((maior, linha) => {
          const valor = linha[coluna] == null ? '' : String(linha[coluna]);
          return Math.max(maior, valor.length);
        }, coluna.length);

        return { wch: maiorConteudo + 1 };
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Ordem Servico');
      XLSX.writeFile(
        workbook,
        'Ordem Servico' + new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }) + '.xlsx',
      );

      dispatch(loadingToggle());
      setGeraExcel(false);
    }
  }, [geraExcel]);

  // useEffect(() => {
  //   if (geraPdf) {
  //     handleDownload();
  //     setGeraPdf(false);
  //   }
  // }, [geraPdf]);

  return (
    <Container>
      <ScrollOS
        className="body"
        // renderView={props => (
        //   <div {...props} style={{ ...props.style, padding: '0 0.8em 10em 0' }} />
        // )}
      >
        <div className="content-os">
          <div className="header">
            <div className="titulo">
              <img src={IconProjeto} alt={'IconOrdem'} />
              <h4 className="title">Ordem de Serviço</h4>
            </div>
            <div className="div-right">
              <button className="btn-excel" onClick={() => setGeraExcel(true)}>
                <img
                  src={localStorage.getItem('tema') == 'E' ? IconExcel : IconExcelB}
                  alt="Icone de Excel"
                />
              </button>
              <button className="btn-pdf" onClick={() => setGeraPdf(true)}>
                <img
                  src={localStorage.getItem('tema') == 'E' ? IconPdf : IconPdfB}
                  alt="Icone de Pdf"
                />
              </button>
              {/* <button className="btn-pdf">
              <OsPdfDownload data={dataPage} filename="Relatorio-OS.pdf" />
              <img
                src={localStorage.getItem('tema') == 'E' ? IconPdf : IconPdfB}
                alt="Icone de Pdf"
              />
            </button> */}
              <div className="pagination">
                <PageButtonIcon
                  type="button"
                  onClick={() => (pagAtiva > 0 ? setPagAtiva(pagAtiva - 1) : setPagAtiva(pagAtiva))}
                  className="material-icons"
                >
                  navigate_before
                </PageButtonIcon>
                <div className="pag-number">{addPagination(pagAtiva + 1, dataPage?.length)}</div>
                <PageButtonIcon
                  type="button"
                  onClick={() => {
                    pagAtiva < dataPage?.length - 1
                      ? setPagAtiva(pagAtiva + 1)
                      : setPagAtiva(pagAtiva);
                  }}
                  className=" material-icons"
                >
                  navigate_next
                </PageButtonIcon>
              </div>
            </div>
          </div>

          <StatsRow>
            <StatCardContent>
              <StatCardRow>
                {/* <StatCard>
                  <span className="label">Ordens de Serviço</span>
                  <span className="value">{stats.totalOS}</span>
                </StatCard> */}

                <StatCard>
                  <span className="label">Total de Translado</span>
                  <span className="value">{stats.translado}h</span>
                </StatCard>
                <StatCard>
                  <span className="label">Total de SRP Autorizado</span>
                  <span className="value">{stats.totalPosHorario}h</span>
                </StatCard>
              </StatCardRow>
              <StatCardRow>
                <StatCard>
                  <span className="label">Total de Movidesk</span>
                  <span className="value">{stats.movidesk}h</span>
                </StatCard>
                <StatCard>
                  <span className="label">Total de Atividade SRP</span>
                  <span className="value">{stats.complementar}h</span>
                </StatCard>
              </StatCardRow>
            </StatCardContent>

            {chartData?.length > 0 && (
              <ResumoStatusCard>
                <Status>
                  {chartData.map((thisData, index) => (
                    <ProposalStateList key={thisData.name + index} color={thisData.fill}>
                      <span>{thisData.surname}</span>
                      <span>{thisData.value}h</span>
                    </ProposalStateList>
                  ))}
                </Status>
                <ChartWrapper>
                  <Chart osData={chartData} />
                </ChartWrapper>
              </ResumoStatusCard>
            )}
          </StatsRow>

          <InputContainer>
            <h4
              style={{
                margin: '0 0 8px 0',
                color: isDarkTheme ? '#fff' : '#6796cf',
                fontSize: '1rem',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <i
                className="material-icons"
                style={{
                  fontSize: '16px',
                  color: isDarkTheme ? '#fff' : '#6796cf',
                }}
              >
                filter_alt
              </i>
              Filtros de Pesquisa
            </h4>

            <InputContent>
              <div style={{ flex: '0 0 auto', minWidth: '140px' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '4px',
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontWeight: '400',
                  }}
                >
                  Id OS
                </label>
                <InputText
                  name="idOS"
                  type="number"
                  placeholder="Id da OS"
                  value={idOS ?? ''}
                  onChange={e => setIdOS(e.target.value || null)}
                />
              </div>

              <div style={{ flex: 2, minWidth: '200px' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '4px',
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontWeight: '400',
                  }}
                >
                  Cliente
                </label>
                <InputSelect
                  options={[{ value: '', label: 'Todos Clientes' }, ...clientesOptions]}
                  placeholder="Selecione o cliente"
                  value={idCliente}
                  onChange={e => setIdCliente(e.target.value || null)}
                  menuPortalTarget={document.body}
                />
              </div>

              <div style={{ flex: 2, minWidth: '220px' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '4px',
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontWeight: '400',
                  }}
                >
                  Analista
                </label>
                <InputSelect
                  options={[{ value: '', label: 'Todos Analistas' }, ...analistasOptions]}
                  placeholder="Selecione o analista"
                  value={idAnalista}
                  onChange={e => setIdAnalista(e.target.value || null)}
                  menuPortalTarget={document.body}
                />
              </div>

              <div style={{ flex: 2, minWidth: '220px' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '4px',
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontWeight: '400',
                  }}
                >
                  Projeto
                </label>
                <InputSelect
                  options={[{ value: '', label: 'Todos Projetos' }, ...projetosOptions]}
                  placeholder="Selecione o projeto"
                  value={idProjeto}
                  onChange={e => setIdProjeto(e.target.value || null)}
                  menuPortalTarget={document.body}
                />
              </div>

              <div style={{ flex: 2, minWidth: '200px' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '4px',
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontWeight: '400',
                  }}
                >
                  Status
                </label>
                <InputSelect
                  isMulti
                  isSearchable={false}
                  options={statusOptions}
                  placeholder="Selecione os status"
                  value={statusAprovacao}
                  onChange={e => setStatusAprovacao(e.target.value)}
                  isClearable={false}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  menuPortalTarget={document.body}
                />
              </div>

              <div style={{ flex: '0 0 auto' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '4px',
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontWeight: '400',
                  }}
                >
                  Emissão de
                </label>
                <InputDate
                  placeholder="Selecione a data"
                  value={previsaoInicio}
                  onChange={date => date && setPrevisaoInicio(date)}
                />
              </div>

              <div style={{ flex: '0 0 auto' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '4px',
                    fontSize: '0.8rem',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontWeight: '400',
                  }}
                >
                  Emissão até
                </label>
                <InputDate
                  placeholder="Selecione a data"
                  value={previsaoFinal}
                  onChange={date => date && setPrevisaoFinal(date)}
                />
              </div>

              <button
                onClick={clearAllFilters}
                style={{
                  padding: '8px',
                  background: Colors.Input_Color_1,
                  border: 'none',
                  borderRadius: '8px',
                  color: Colors.text_Color_1,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '0.85rem',
                  transition: 'all 0.3s ease',
                  height: '36px',
                }}
                onMouseEnter={e => {
                  e.target.style.background = `${Colors.Input_Color_1}90`;
                }}
                onMouseLeave={e => {
                  e.target.style.background = Colors.Input_Color_1;
                }}
                title="Limpar Filtros"
              >
                <i className="material-icons" style={{ fontSize: '18px' }}>
                  filter_list_off
                </i>
              </button>
            </InputContent>
          </InputContainer>

          {/* <ScrollOS className="body"> */}
          <div className="display-oc" ref={pdfRef}>
            <ThisCard className="card-header" {...{ linhaAtiva, setLinhaAtiva }} ativo={false}>
              <div className="row">
                <div className="col w1">
                  <div className="card-cod">
                    <p className="cod">Id</p>
                  </div>
                </div>
                <div className="col w1">
                  <p>Emissão</p>
                </div>
                <div className="col w3">
                  <p>Título</p>
                </div>
                <div className="col w3">
                  <p>Analista</p>
                </div>
                <div className="col w2">
                  <p>Etapa</p>
                </div>
                <div className="col w1 center">
                  <p>Apontada</p>
                </div>
                <div className="col w1 center">
                  <p>Desconto</p>
                </div>
                <div className="col w1 center">
                  <p>Translado</p>
                </div>
                <div className="col w1 center">
                  <p>SRP Autorizado</p>
                </div>
                <div className="col w1 center">
                  <p>Total</p>
                </div>
                <div className="col w3">
                  <p>Projeto</p>
                </div>
                <div className="col w2">
                  <p>Cliente</p>
                </div>
                <div className="col w2">
                  <p>Aprovador 1</p>
                </div>
                <div className="col w2">
                  <p>Aprovador 2</p>
                </div>
              </div>
            </ThisCard>
            {dataPage[pagAtiva]?.map((thisProjeto, i) => (
              <ThisCard
                className={linhaAtiva === thisProjeto?.id ? 'card-item ativo' : 'card-item'}
                {...{ data: thisProjeto, linhaAtiva, setLinhaAtiva }}
                key={thisProjeto?.id || i}
                id={thisProjeto?.id || i}
                index={i}
                ativo={linhaAtiva === thisProjeto?.id ? true : false}
              >
                <div className="row">
                  <div className="col w1">
                    <div className="card-cod">
                      <p className="cod">#{thisProjeto?.id}</p>
                    </div>
                  </div>
                  <div className="col w1">
                    <p>
                      {
                        new Date(thisProjeto?.dataEmissao)
                          .toLocaleString('pt-BR', { timeZone: 'UTC' })
                          .split(',')[0]
                      }
                    </p>
                  </div>
                  <div className="col w3">
                    <p>{thisProjeto?.titulo}</p>
                  </div>
                  <div className="col w3">
                    <p>{thisProjeto?.analista?.nome}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.descricaoStatusAprov}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{formatarHoraDecimal(thisProjeto?.horaApontada)}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{formatarHoraDecimal(thisProjeto?.horaDesconto)}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{formatarHoraDecimal(thisProjeto?.horaTranslado)}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{getTotalPosHorarioItem(thisProjeto)}</p>
                  </div>
                  <div className="col w1 center">
                    <p>{formatarHoraDecimal(thisProjeto?.horaTotal)}</p>
                  </div>
                  <div className="col w3">
                    <p>{thisProjeto?.projeto?.titulo}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.cliente?.nomeFantasia}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.coordenador?.nome}</p>
                  </div>
                  <div className="col w2">
                    <p>{thisProjeto?.coordenadorTec?.nome}</p>
                  </div>
                </div>
              </ThisCard>
            ))}
          </div>
          {/* </ScrollOS> */}
        </div>
        <div className="pagination-footer">
          <div className="pagination">
            <PageButtonIcon
              type="button"
              onClick={() => (pagAtiva > 0 ? setPagAtiva(pagAtiva - 1) : setPagAtiva(pagAtiva))}
              className="material-icons"
            >
              navigate_before
            </PageButtonIcon>
            <div className="pag-number">{addPagination(pagAtiva + 1, dataPage?.length)}</div>
            <PageButtonIcon
              type="button"
              onClick={() => {
                pagAtiva < dataPage?.length - 1 ? setPagAtiva(pagAtiva + 1) : setPagAtiva(pagAtiva);
              }}
              className=" material-icons"
            >
              navigate_next
            </PageButtonIcon>
          </div>
        </div>
      </ScrollOS>
    </Container>
  );
  // return (
  //   <Container>
  //     <div className="content-oc">
  //       <SectionProjeto height={"22em"}>
  //         <div className="header">
  //           <div className="div-icone">
  //             <img src={IconProjeto} alt={"IconProjeto"} />
  //             <h4 className="title">Ordem de Serviço</h4>
  //           </div>
  //           <div className="div-right">
  //             <button className="btn-excel" onClick={() => setGeraExcel(true)}>
  //               <img src={localStorage.getItem("tema") == "E" ? IconExcel : IconExcelB} alt="Icone de Excel" />
  //             </button>
  //             <button className="btn-pdf" onClick={() => setGeraPdf(true)}>
  //               <img src={localStorage.getItem("tema") == "E" ? IconPdf : IconPdfB} alt="Icone de Pdf" />
  //             </button>
  //             <div className="pagination">
  //               <PageButtonIcon
  //                 type="button"
  //                 onClick={() => pagAtiva > 0 ? setPagAtiva(pagAtiva - 1) : setPagAtiva(pagAtiva)}
  //                 className="material-icons"
  //               >
  //                 navigate_before
  //               </PageButtonIcon>
  //               <div className="pag-number">
  //                 {addPagination(pagAtiva + 1, dataPage?.length)}
  //               </div>
  //               <PageButtonIcon
  //                 type="button"
  //                 onClick={() => { pagAtiva < (dataPage?.length - 1) ? setPagAtiva(pagAtiva + 1) : setPagAtiva(pagAtiva) }}
  //                 className=" material-icons"
  //               >
  //                 navigate_next
  //               </PageButtonIcon>
  //             </div>
  //           </div>
  //         </div>
  //         <ScrollOS>
  //           <div className="display-oc" ref={pdfRef}>
  //             <ThisCard
  //               className="card-header"
  //               {...{ linhaAtiva, setLinhaAtiva }}
  //               ativo={false}
  //             >
  //               <div className="row">
  //                 <div className="col w1">
  //                   <div className="card-cod">
  //                     <p className="cod">Id</p>
  //                   </div>
  //                 </div>
  //                 <div className="col w1">
  //                   <p>Emissão</p>
  //                 </div>
  //                 <div className="col w3">
  //                   <p>Título</p>
  //                 </div>
  //                 <div className="col w3">
  //                   <p>Analista</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Etapa</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Apontada</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Desconto</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Translado</p>
  //                 </div>
  //                 <div className="col w1 center">
  //                   <p>Total</p>
  //                 </div>
  //                 <div className="col w3">
  //                   <p>Projeto</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Cliente</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Aprovador 1</p>
  //                 </div>
  //                 <div className="col w2">
  //                   <p>Aprovador 2</p>
  //                 </div>
  //               </div>
  //             </ThisCard>
  //             {dataPage[pagAtiva]?.map((thisProjeto, i) => (
  //               <ThisCard
  //                 className={
  //                   linhaAtiva === thisProjeto?.id ? 'card-item ativo' : 'card-item'
  //                 }
  //                 {...{ data: thisProjeto, linhaAtiva, setLinhaAtiva }}
  //                 key={thisProjeto?.id || i}
  //                 id={thisProjeto?.id || i}
  //                 index={i}
  //                 ativo={linhaAtiva === thisProjeto?.id ? true : false}
  //               >
  //                 <div className="row">
  //                   <div className="col w1">
  //                     <div className="card-cod">
  //                       <p className="cod">#{thisProjeto?.id}</p>
  //                     </div>
  //                   </div>
  //                   <div className="col w1">
  //                     <p>{((new Date(thisProjeto?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
  //                   </div>
  //                   <div className="col w3">
  //                     <p>{thisProjeto?.titulo}</p>
  //                   </div>
  //                   <div className="col w3">
  //                     <p>{thisProjeto?.analista?.nome}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.descricaoStatusAprov}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaApontadaMascara}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaDescontoMascara}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaTransladoMascara}</p>
  //                   </div>
  //                   <div className="col w1 center">
  //                     <p>{thisProjeto?.horaTotalMascara}</p>
  //                   </div>
  //                   <div className="col w3">
  //                     <p>{thisProjeto?.projeto?.titulo}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.cliente?.nomeFantasia}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.coordenador?.nome}</p>
  //                   </div>
  //                   <div className="col w2">
  //                     <p>{thisProjeto?.coordenadorTec?.nome}</p>
  //                   </div>
  //                 </div>
  //               </ThisCard>
  //             ))}
  //           </div>
  //         </ScrollOS>
  //       </SectionProjeto>
  //     </div>
  //   </Container>
  // );
}

export default CustomBodyContent;
